import { ReactNode } from 'react';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './Placeholder.module.scss';

export type Props = {
  children: ReactNode;
  dataTest?: string;
  placeholder?: string;
  loading?: boolean;
  /** Replace current children with placeholder */
  replace?: boolean;
  className?: string;
};

export default function Placeholder({
  children,
  loading,
  placeholder,
  dataTest = 'placeholder',
  replace = false,
  className,
}: Props) {
  const { t } = useTranslation('common');
  return (
    <span
      className={classes(loading && styles.wrapper, className)}
      data-test={dataTest}
    >
      {(children || children === 0 || children === '') && (!replace || !loading)
        ? children
        : placeholder || t('loading')}
    </span>
  );
}
